"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconParcelClockOutline = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("b2b-components/core/components/Icon/Icon/SvgWrapper");
const IconParcelClockOutline = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 17.26V6.61l9.3-5.31 9.275 5.312v5.234h-2.15V9.035l-7.125 4.15L5.15 9.01v6.938l7.606 4.386v2.514L3 17.26Zm13.438-8.951 1.837-1.067L12.3 3.798l-1.724.994 5.862 3.517Zm-2.124 1.233-5.867-3.52.003-.005-2.125 1.225 5.975 3.47 2.014-1.17Zm5.114 13.912c-1.249 0-2.311-.438-3.187-1.313-.875-.876-1.313-1.938-1.313-3.187 0-1.249.438-2.31 1.313-3.186.876-.876 1.938-1.314 3.187-1.314 1.248 0 2.31.438 3.186 1.314.876.875 1.314 1.937 1.314 3.186 0 1.249-.438 2.31-1.314 3.187-.875.875-1.938 1.313-3.186 1.313Zm.517-4.954v-3.084H18.91v3.997h3.44V18.5h-2.405Z"
}));
exports.IconParcelClockOutline = IconParcelClockOutline;
//# sourceMappingURL=IconParcelClockOutline.js.map